// Svenska röda dagar – beräknas lokalt, ingen extern tjänst.
const ymd = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const easter = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
};

const shift = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

const nthWeekday = (year, month, weekday, afterDay) => {
  const d = new Date(year, month - 1, afterDay);
  while (d.getDay() !== weekday) d.setDate(d.getDate() + 1);
  return d;
};

const cache = {};

export const holidaysFor = (year) => {
  if (cache[year]) return cache[year];
  const e = easter(year);
  const midsummerEve = nthWeekday(year, 6, 5, 19);
  const allSaints = nthWeekday(year, 10, 6, 31);
  const list = [
    [new Date(year, 0, 1), "Nyårsdagen"],
    [new Date(year, 0, 6), "Trettondedag jul"],
    [shift(e, -3), "Skärtorsdagen"],
    [shift(e, -2), "Långfredagen"],
    [e, "Påskdagen"],
    [shift(e, 1), "Annandag påsk"],
    [new Date(year, 3, 30), "Valborgsmässoafton"],
    [new Date(year, 4, 1), "Första maj"],
    [shift(e, 39), "Kristi himmelsfärdsdag"],
    [shift(e, 49), "Pingstdagen"],
    [new Date(year, 5, 6), "Sveriges nationaldag"],
    [midsummerEve, "Midsommarafton"],
    [shift(midsummerEve, 1), "Midsommardagen"],
    [allSaints, "Alla helgons dag"],
    [new Date(year, 11, 24), "Julafton"],
    [new Date(year, 11, 25), "Juldagen"],
    [new Date(year, 11, 26), "Annandag jul"],
    [new Date(year, 11, 31), "Nyårsafton"],
  ];
  cache[year] = Object.fromEntries(list.map(([d, name]) => [ymd(d), name]));
  return cache[year];
};

export const holidayName = (dateOrKey) => {
  const key = typeof dateOrKey === "string" ? dateOrKey.slice(0, 10) : ymd(dateOrKey);
  return holidaysFor(Number(key.slice(0, 4)))[key] || "";
};

/** Lördagar, söndagar och röda dagar mellan två datum (ISO-strängar). */
export const freeDaysBetween = (startIso, endIso) => {
  if (!startIso) return [];
  const start = new Date(`${startIso.slice(0, 10)}T00:00:00`);
  const end = new Date(`${(endIso || startIso).slice(0, 10)}T00:00:00`);
  const out = [];
  for (let d = start; d <= end; d = shift(d, 1)) {
    const key = ymd(d);
    const name = holidayName(key);
    if (name) out.push({ date: key, name });
    else if (d.getDay() === 0) out.push({ date: key, name: "Söndag" });
    else if (d.getDay() === 6) out.push({ date: key, name: "Lördag" });
  }
  return out;
};
